// src/utils/fetchLocationByIP.js
let cachedLocation = null;
let didFetch = false;

export default async function fetchLocationByIP() {
    if (didFetch) {
        return cachedLocation;
    }

    didFetch = true;

    try {
        const response = await fetch(`https://api.ipdata.co?api-key=${process.env.REACT_APP_IPDATA_API_KEY}`);
        if (!response.ok) {
            console.error('Ошибка при обращении к ipdata:', response.status, response.statusText);
            return null;
        }

        const data = await response.json();

        // Проверяем, что в ответе есть и city, и region
        if (data && data.city && data.region) {
            cachedLocation = {
                city: data.city,
                region: data.region,
            };
            return cachedLocation;
        } else {
            console.error('Не удалось получить город или штат из ответа IP-данных:', data);
            return null;
        }
    } catch (error) {
        console.error('Ошибка при запросе к ipdata:', error);
        return null;
    }
}